import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { combineLatest, map } from 'rxjs';
import { HighlightFeedback } from '../../../../team-apis/otterdam/feedback';
import { FeedbackItemComponent } from '../../../feedback/views/feedback-item/feedback-item.component';
import { TaskWorkspaceStore } from '../../../h3ml/state/task-workspace-store';
import { SamplingWorkspaceStore } from '../../../sampling-workspace/state/sampling-workspace-store';
import { HighlightFeedbackPanelService } from '../../services/highlight-feedback-panel.service';
import { HighlightService } from '../../services/highlight.service';

@Component({
  selector: 'h3-highlight-feedback-item',
  templateUrl: './highlight-feedback-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FeedbackItemComponent],
})
export class HighlightFeedbackItemComponent {
  @Input({ required: true }) highlightFeedback!: HighlightFeedback;

  private readonly store = inject(TaskWorkspaceStore);
  private readonly sampleStore = inject(SamplingWorkspaceStore);
  private readonly highlightService = inject(HighlightService);
  private readonly highlightFeedbackPanelService = inject(
    HighlightFeedbackPanelService,
  );

  isSelected$ = this.store('highlightState')('selected').$.pipe(
    map(
      (highlight) =>
        highlight?.feedbackId === this.highlightFeedback.feedbackId,
    ),
  );
  isEditAllowed$ = combineLatest([
    this.store('workspace').$,
    this.sampleStore.hasSampleFinalized$(),
  ]).pipe(
    map(
      ([workspace, hasSampleFinalized]) =>
        workspace === 'sampling' && !hasSampleFinalized,
    ),
  );
  isDeleteAllowed = this.store.state().workspace === 'sampling';

  getSubtitle() {
    return `#${this.highlightFeedback.objectId}`;
  }

  editFeedback() {
    this.highlightFeedbackPanelService.showEditHighlight();
  }

  deleteFeedback() {
    this.highlightService.deleteSelectedHighlight();
  }

  selectFeedback() {
    this.highlightService.selectHighlight(this.highlightFeedback);
  }
}
